<template>
  <div class="b2b-form">
    <el-card>
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="100px"
        :inline="true"
        label-position="right"
      >
        <el-alert
          class="info-title"
          title="出库单信息"
          type="info"
          :closable="false"
        >
        </el-alert>
        <el-row class="info">
          <el-col :span="8">
            <el-form-item label="出库订单号" prop="outBizId">
              <el-input v-model="form.outBizId"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="仓库id" prop="warehouseId">
              <el-input v-model="form.warehouseId"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="货主id" prop="customerId">
              <el-select
                filterable
                v-model="form.customerId"
                placeholder="请选择货主"
              >
                <el-option
                  v-for="item in getCustomerList"
                  :label="item.label"
                  :value="item.value"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-alert
          class="info-title"
          title="收件信息"
          type="info"
          :closable="false"
        ></el-alert>
        <el-row class="info">
          <el-col :span="8">
            <el-form-item label="省" prop="province">
              <el-input v-model="form.province"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="市">
              <el-input v-model="form.city"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="区">
              <el-input v-model="form.district"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="详细地址">
              <el-input v-model="form.address"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收件人">
              <el-input v-model="form.consignee"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系方式">
              <el-input v-model="form.phone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-alert
          class="info-title"
          title="出库单明细"
          type="info"
          :closable="false"
        >
          <el-link
            type="primary"
            :href="templateUrl"
            style="margin-right: 10px"
          >
            下载导入模板
          </el-link>
          <el-button
            style="margin-right: 10px;"
            type="primary"
            @click="importGoods"
          >
            导入商品
          </el-button>
          <input
            id="upFile"
            type="file"
            style="display: none"
            accept=".xlsx, .xls"
            @change="upChange"
          />
          <el-button type="primary" @click="showSelectGoods">
            选择商品
          </el-button>
        </el-alert>
        <el-row class="info">
          <el-table :data="goods">
            <el-table-column align="center" prop="index" label="序号">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="customerId"
              label="货主id"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="skuName"
              label="商品名称"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="itemNo"
              label="商品料号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="barcode"
              label="商品条码"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="stockCustomsNum"
              label="海关库存"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="wmsNum"
              label="库存"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="planStockoutQuantity"
              label="计划出库数量"
              width="150"
            >
              <template slot-scope="scope">
                <el-input-number
                  style="width: 100%"
                  v-model.number="scope.row.planStockoutQuantity"
                  size="mini"
                  :controls="false"
                  :precision="0"
                />
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="errMsg"
              label="校验信息"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="planStockoutQuantity"
              label="操作"
              width="150"
            >
              <template slot-scope="scope">
                <el-link
                  size="mini"
                  type="danger"
                  @click="deleteGoods(scope.row.id)"
                  >删除</el-link
                >
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-form>
      <goods-select-dialog
        :visible.sync="visible"
        @close="close"
        @on-select="handleSelect"
      />
      <el-row justify="center" type="flex">
        <el-button
          style="margin-top: 20px"
          type="primary"
          @click="createStockoutOrder"
        >
          保存
        </el-button>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import GoodsSelectDialog from "./components/GoodsSelectDialog.vue";
import lodash from "lodash";
import b2bApi from "@/api/b2b";
import recordApi from "@/api/record";
import * as XLSX from "xlsx";
import { mapGetters } from "vuex";
import { CONST_IMPORT_OUTBOUND_SKU_TEMPLATE_URL } from "@/config/constant";
export default {
  components: {
    GoodsSelectDialog,
  },
  data() {
    return {
      templateUrl: CONST_IMPORT_OUTBOUND_SKU_TEMPLATE_URL,
      visible: false,
      form: {
        outBizId: "",
        warehouseId: "",
        customerId: "",
        province: "",
        city: "",
        district: "",
        address: "",
        consignee: "",
        phone: "",
      },
      goods: [],
      rules: {
        outBizId: [
          { required: true, message: "请输入出库单号", trigger: "blur" },
        ],
        warehouseId: [
          { required: true, message: "请输入仓库id", trigger: "blur" },
        ],
        customerId: [
          { required: true, message: "请输入货主id", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    importGoods() {
      if (!this.form.customerId) {
        this.$message.error("请先选择货主id");
        return;
      }
      const upFileButton = document.getElementById("upFile");
      upFileButton.click();
    },
    upChange(e) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.readAsBinaryString(file);
      reader.onload = async (event) => {
        try {
          const data = event.target.result;
          const workbook = XLSX.read(data, { type: "binary" });
          const sheet = workbook.Sheets[workbook.SheetNames[0]];
          const json = XLSX.utils.sheet_to_json(sheet, { header: 1 });
          if (json.length === 0) {
            this.$message.error("请检查文件");
            e.target.value = "";
            return;
          }
          if (json.length === 1) {
            this.$message.error("excel数据不能为空");
            e.target.value = "";
            return;
          }
          const originList = json.slice(1).map((item) => ({
            itemNo: item[0].toString(),
            quantity: item[1],
          }));

          const res = await recordApi.accountBookQueryAll({
            request: {
              customerId: this.form.customerId,
              itemNos: originList.map((item) => item.itemNo),
            },
          });

          const list = originList.map((item) => {
            const record = res.items.find((r) => r.itemNo === item.itemNo);
            if (!record) {
              return {
                itemNo: item.itemNo,
                planStockoutQuantity: item.quantity,
                errMsg: "商品不存在",
              };
            }
            const ret = {
              id: record.id,
              itemNo: record.itemNo,
              skuName: record.declareName,
              barcode: record.barcodes,
              customerId: record.customerId,
              wmsNum: record.wmsNum,
              stockCustomsNum: record.stockCustomsNum,
              errMsg: "",
              planStockoutQuantity: item.quantity,
            };
            return ret;
          });

          this.goods = lodash.uniqBy([...this.goods, ...list], "itemNo");

          e.target.value = "";
        } catch (err) {
          e.target.value = "";
          console.error(err);
        }
      };
    },
    showSelectGoods() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    deleteGoods(id) {
      this.$confirm("确认删除?", "删除出库单商品", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        this.goods = this.goods.filter((item) => item.id !== id);
      });
    },
    handleSelect(rows) {
      const list = rows.map((item) => ({
        id: item.id,
        itemNo: item.itemNo,
        skuName: item.declareName,
        barcode: item.barcodes,
        customerId: item.customerId,
        wmsNum: item.wmsNum,
        stockCustomsNum: item.stockCustomsNum,
      }));
      this.goods = lodash.uniqBy([...this.goods, ...list], "id");
    },
    createStockoutOrder() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          b2bApi
            .create({
              request: {
                type: "STOCKOUT",
                ...this.form,
                items: this.goods.map((g) => ({
                  stockId: g.id,
                  planStockoutQuantity: g.planStockoutQuantity,
                })),
              },
            })
            .then((res) => {
              if (res.value) {
                this.$message.success("创建成功");
                this.$router.replace({
                  name: "b2b",
                });
              }
            });
        }
      });
    },
  },
  computed: {
    ...mapGetters({
      getCustomerList: "getCustomerList",
    }),
  },
};
</script>

<style lang="scss">
.b2b-form {
  .info-title {
    height: 50px;
    background: #f5f5f5;
    color: #17181a;
    font-weight: bold;
    line-height: 50px;
  }

  .el-alert__title {
    font-size: 20px;
    line-height: 55px;
  }

  .info {
    padding: 10px 20px 10px;
  }

  .el-alert__content {
    display: flex;
    width: 100%;
    justify-content: space-between;

    .tip {
      color: #ff3333;
    }
  }
}
</style>
